'use strict'

const mapNumber = (data) => {
  const type = _.eq(data.type, 'sector') ? 'sector' : 'num'
  let betting = null
  if (type === 'sector') {
    const sector = data.sector
    const sectors = {
      1: 'COLUMNx3rd', 2: 'COLUMNx2nd', 3: 'COLUMNx1st',
      4: 'DOZENx1st', 5: 'DOZENx2nd', 6: 'DOZENx3rd',
      7: 'HALFxSMALL', 8: 'HALFxEVEN', 9: 'HALFxRED', 10: 'HALFxBLACK', 11: 'HALFxODD', 12: 'HALFxBIG'
    }
    betting = sectors[sector]
  } else {
    const number = data.num
    const numbers = _.split( number, ',')
    const getBettingType = (numbers) => {
      numbers = _.chain(numbers).map(n => parseInt(n)).orderBy().value()
      const len = numbers.length
      const posibles = {
        1: function (numbers) {
          return 'STRAIGHTUPx' + numbers.join('-')
        },
        2: function (numbers) {
          return 'SPLITx' + numbers.join('-')
        },
        3: function (numbers) {
          return 'STREETx' + numbers.join('-')
        },
        4: function (numbers) {
          const typeOnfour = _.isEqual([0,1,2,3], numbers) ? 'BASKET' : 'SQUARE'
          return typeOnfour + 'x' + numbers.join('-')
        },
        6: function (numbers) {
          return 'LINEx' + _.head(numbers) + '-' + _.last(numbers)
        }
      }
      return posibles[len](numbers)
    }
    betting = getBettingType(numbers)
  }
  return betting
}

const mapColor = (no) => {
  no = parseInt(no)
  if (no === 0) return 'white'
  const reds = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36]
  return reds.indexOf(no) !== -1 ? 'red' : 'black'
}

export { mapNumber, mapColor }



// WEBPACK FOOTER //
// ./resources/assets/js/roulette/helpers.js